module.exports = __webpack_public_path__ + "img/stitch.80216fa2.jpg";